import React from "react";
import { ReactComponent as Cooking } from "../icons/cooking.svg";
import { ReactComponent as Delivered } from "../icons/delivered.svg";
import { ReactComponent as Pending } from "../icons/pending.svg";

const iconOrderChefComponents = [<Pending />, <Cooking />, <Delivered />];
export default iconOrderChefComponents;
